import React from "react";

interface CustomSelectProps {
  options: string[];
  value: string;
  onChange: (value: string) => void;
  width: string;
}

export default function CustomSelect({
  options,
  value,
  onChange,
  width
}: CustomSelectProps) {
  return (
    <div
      className={`relative text-slate-800 text-sm font-normal border border-slate-300 rounded-lg ${width}`}
    >
      <select
        className="w-full text-sm font-normal bg-white rounded-lg border-none px-4 py-2 pr-9 appearance-none focus:outline-none focus:ring-0"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option || ""}
          </option>
        ))}
      </select>
      <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
        <i className="transition fa-solid fa-angle-down  text-slate-400 mr-1"></i>
      </div>
    </div>
  );
}
